import { render, staticRenderFns } from "./CustomJavaScript.vue?vue&type=template&id=18927799"
import script from "./CustomJavaScript.vue?vue&type=script&lang=js"
export * from "./CustomJavaScript.vue?vue&type=script&lang=js"
import style0 from "./CustomJavaScript.vue?vue&type=style&index=0&id=18927799&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports